// extracted by mini-css-extract-plugin
export default {"button":"bm-z","reviewSort":"cm-z"};